export const integrationsKeys = {
  httpConnections: (entityId: string) =>
    ['integrations', 'http-connections', entityId] as const,
}
